export const WISHLIST_TOGGLE_ID = 'wishlist/WISHLIST_TOGGLE_ID';
export const WISHLIST_REMOVE_ID = 'wishlist/WISHLIST_REMOVE_ID';
export const WISHLIST_CLEAR = 'wishlist/WISHLIST_CLEAR';
